import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  IMiniStressScoringPayload,
  ActionType,
  IMiniStressScoringResponse,
} from "models/stressCheck/miniStressScoringInformation";
import { httpStatus } from "configs/httpStatus";
import { getMiniStressScoringInfomation } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./miniStressScoringInfoActions";

function* getMiniStressScoringSaga({
  payload,
}: {
  payload: IMiniStressScoringPayload;
}) {
  try {
    const response: IMiniStressScoringResponse = yield call(
      getMiniStressScoringInfomation,
      payload
    );

    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else if (response.status === httpStatus.StatusUnauthorized) {
      yield put(handleErrorAction(response.message || ""));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetMiniStressScoringWatcher() {
  yield takeLatest(
    ActionType.MINI_STRESS_SCORING as any,
    getMiniStressScoringSaga
  );
}

export default [fork(onGetMiniStressScoringWatcher)];
